import { createFileRoute, Outlet } from '@tanstack/react-router';

import { usePathname } from '@/lib/compat/navigation';
import { AppSidebarShell } from '@/components/layout/app-sidebar-shell';
import { ConditionalProviders } from '@/components/providers/conditional-providers';
import { isAuthRoute } from '@/lib/utils/auth-routes';

/**
 * Authenticated application layer. Mounts the full session/provider stack
 * (formerly the non-public branch of `ConditionalProviders`): session,
 * MFA/billing enforcement, feature flags, file-upload config, app-shell
 * runtime. Public routes live outside this pathless layout and skip it.
 *
 * App sections (chat / settings / …) are wrapped in the shared `AppSidebarShell`
 * so the sidebar persists across navigation between them. Auth pages (login,
 * signup, password reset, invite, oauth) render bare — no sidebar.
 */
export const Route = createFileRoute('/_app')({
  component: AppLayout,
});

function AppSections() {
  const pathname = usePathname();

  if (isAuthRoute(pathname)) {
    return <Outlet />;
  }
  return (
    <AppSidebarShell>
      <Outlet />
    </AppSidebarShell>
  );
}

function AppLayout() {
  return (
    <ConditionalProviders>
      <AppSections />
    </ConditionalProviders>
  );
}
